<ng-container *transloco="let t; read: 'time-entries'">
  <h3 class="pbm">{{ t("tracking.entires-today") }}</h3>
  <app-time-entry-grid
    [timeEntries]="timeEntriesGrid$ | async"
    [searchRequest]="searchRequest"
    [timeEntryCategories]="timeEntryCategories"
    (onUpdateGrid)="reloadTimeEntries()"
  ></app-time-entry-grid>
</ng-container>
